import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import PublicRoutes from './public/public.routes';
import PrivateRoutes from './private/private.routes';
import AuthHandler from './public/components/auth-handler/AuthHandler';
import { useRouteStore } from "../core/store/route.store";

const AppRoutes: React.FC = () => {
  const routePrefix = useRouteStore((state) => state.routePrefix);

  return (
    <>
      <AuthHandler />
      <Routes>
        <Route path="/*" element={<PublicRoutes />} />
        <Route path={`${routePrefix}/*`} element={<PrivateRoutes />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

const App: React.FC = () => (
  <Router
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <AppRoutes />
  </Router>
);

export default App;